var CONTRACTCODE = /^[\u4e00-\u9fa5_a-zA-Z0-9\-\[\]\(\)\（\）]+$/;
export { CONTRACTCODE };
